import ParisFactory from '@baidu/paris';
import setupOfflineToken from '@baidu/paris/lib/offlineToken';

// setupOfflineToken注册容灾时的离线token能力，当acsToken生成发生异常时，使用本地生成paris模块生成的离线token
setupOfflineToken(ParisFactory);

// sid/sak，由管理员分配
const sid=2162
const sak='d8856a7de6'

export const initParis = () => {
    ParisFactory.create({
    sid: sid,
    sak: sak,
    timeout: 5000, // CDN的请求超时时间
    bantiUrl: `https://banti-static.cdn.bcebos.com/o/static/banti_${sak}.js`,
    acsUrl: `https://dlswbr.baidu.com/heicha/mm/${sid}/acs-${sid}.js`,
    // 容灾配置
    disasterConfig: {
        // 备用CDN地址
        acsUrl: `https://miaowu.baidu.com/sdk/heicha/mm/${sid}/acs-${sid}.js`
    },
    bantiOptions: {
        subid: function () {
            // 返回当前页面子渠道号，例如：根据当前页面返回页面英文名
            // pc 渠道号
            return 'pc_chat';
        }
    }
});
}
// 加载后请立即初始化配置


// 获取签名
export async function getAcsToken(opts = {subid: String(sid)}) { // subid业务场景的子渠道号

    const parisInstance = (window as any)[`paris_${sid}`];
    // getAcsToken函数被try/catch包裹，无需处理reject
    return new Promise<string>(resolve => {
        // 必须保证在ParisFactory.create同时传入acsUrl与bantiUrl
        parisInstance.getAcsTokenWithBantiSend(opts, (acsToken: string) => {
            resolve(acsToken);
        });
    });
}
